// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NotificationDropdownController from "./notification_dropdown_controller"
application.register("notification-dropdown", NotificationDropdownController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import TurboFrameRefreshController from "./turbo_frame_refresh_controller"
application.register("turbo-frame-refresh", TurboFrameRefreshController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import BillableToggleController from "./billable_toggle_controller"
application.register("billable-toggle", BillableToggleController)

import TagSelectorController from "./tag_selector_controller"
application.register("tag-selector", TagSelectorController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import WorkflowDiagramController from "./workflow_diagram_controller"
application.register("workflow-diagram", WorkflowDiagramController)

import ProgressiveRevealController from "./progressive_reveal_controller"
application.register("progressive-reveal", ProgressiveRevealController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import DocumentTypeOtherController from "./document_type_other_controller"
application.register("document-type-other", DocumentTypeOtherController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import SelectNavigateController from "./select_navigate_controller"
application.register("select-navigate", SelectNavigateController)

import ResumeRevealController from "./resume_reveal_controller"
application.register("resume-reveal", ResumeRevealController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import ApplicantCustomFieldsController from "./applicant_custom_fields_controller"
application.register("applicant-custom-fields", ApplicantCustomFieldsController)

import CustomFieldsBatchDeleteController from "./custom_fields_batch_delete_controller"
application.register("custom-fields-batch-delete", CustomFieldsBatchDeleteController)

import CustomFieldFormController from "./custom_field_form_controller"
application.register("custom-field-form", CustomFieldFormController)

import FieldTemplateFormController from "./field_template_form_controller"
application.register("field-template-form", FieldTemplateFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import HistoryBackController from "./history_back_controller"
application.register("history-back", HistoryBackController)

import AdvancedSearchToggleController from "./advanced_search_toggle_controller"
application.register("advanced-search-toggle", AdvancedSearchToggleController)

import RetryCountdownController from "./retry_countdown_controller"
application.register("retry-countdown", RetryCountdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import SanitizedUploadController from "./sanitized_upload_controller"
application.register("sanitized-upload", SanitizedUploadController)

import CohortUploadStatusController from "./cohort_upload_status_controller"
application.register("cohort-upload-status", CohortUploadStatusController)

import SignedUploadStatusController from "./signed_upload_status_controller"
application.register("signed-upload-status", SignedUploadStatusController)

import PermissionGroupToggleController from "./permission_group_toggle_controller"
application.register("permission-group-toggle", PermissionGroupToggleController)

import RowClickController from "./row_click_controller"
application.register("row-click", RowClickController)

import ProblemReportContextController from "./problem_report_context_controller"
application.register("problem-report-context", ProblemReportContextController)

import TemplateScopeController from "./template_scope_controller"
application.register("template-scope", TemplateScopeController)
